module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "out"
  }, [_c('pullScroll', {
    attrs: {
      "on-refresh": _vm.onRefresh,
      "on-infinite": _vm.onInfinite,
      "loading-text": _vm.loadingText,
      "enableInfinite": _vm.enableInfinite
    }
  }, [_c('ul', {
    attrs: {
      "id": "topicList"
    }
  }, _vm._l((_vm.topicLists), function(item) {
    return _c('li', {
      key: item.id
    }, [_c('discussDetail', {
      attrs: {
        "discussItem": item,
        "sid": _vm.sid
      },
      on: {
        "showSwiper": _vm.detailShowSwiper,
        "detailShowPopover": _vm.detailShowPopover
      }
    })], 1)
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-047c35ef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/topic/list.vue
// module id = 283
// module chunks = 1